<template>
  <ZoomOneEduPlanDetail v-bind="{ visible, id, currencySymbol, enableDisplayZoomWorkFlow, bizCategoryCode, largeMeetingCallback, fullListCallBack, enableDocsFeature, enableDisplayZoomTasksWithoutAccountCheck, showCampusScheduler, isEligibleAccount4CustomAvatarFeature }" @closed="handleCancel">
    <p slot="footer" class="zone-detail-dialog__tips">
      *{{ $t('billing.zone.edu_details.tips', [20, $money(annualPriceNum * 20, { forceDiff: true })]) }}
    </p>
  </ZoomOneEduPlanDetail>
</template>

<script>
import { mapGetters } from 'vuex';

import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import { getCurrency, getCurrencySymbol } from "@/utils/currency";
import { plansof } from '@/utils/chain';
import { planTypes } from '@/common/constants';
import { ZOOM_MEETING_SUB_TYPES } from '../common/utils'

export default {
  name: 'ZoomOneEduSchoolCampsDetail',
  mixins: [ConfirmComponent],
  props: {
    largeMeetingCb: Function,
  },
  data() {
    return {
      visible: false,
      id: 'school',
      bizCategoryCode: ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP,
      currencySymbol: getCurrencySymbol(getCurrency()),
      enableDocsFeature: window.newBillingConfig.enableDocsFeature,
      showCampusScheduler: window.newBillingConfig.enableCampusScheduler,
      enableDisplayZoomTasksWithoutAccountCheck: window.newBillingConfig.enableDisplayZoomTasksWithoutAccountCheck,
      isEligibleAccount4CustomAvatarFeature: window.newBillingConfig.isEligibleAccount4CustomAvatarFeature,
      enableDisplayZoomWorkFlow: window.newBillingConfig.enableDisplayZoomWorkFlow,
    }
  },
  computed: {
    ...mapGetters(['planMapFlat']),
    annualPriceNum() {
      const eduAnnualPlan = plansof(this.planMapFlat)
      .type(planTypes.ZOOM_MEETING)
      .category(ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP).annual().get(0);
      return eduAnnualPlan?.amount;
    },
    largeMeetingCallback() {
      if (typeof this.largeMeetingCb == 'function') {
        return () => {
          this.largeMeetingCb()
          this.handleCancel()
        }
      }
      return null
    }
  },
  methods: {
    fullListCallBack() {
      this.handleSure()
    }
  }
}
</script>
